import { createContext } from 'react';
import {
  Control,
  FieldValues,
  FormState,
  UseFormClearErrors,
  UseFormRegister,
  UseFormReset,
  UseFormResetField,
  UseFormSetError,
  UseFormWatch,
} from 'react-hook-form';
import { createStore } from 'zustand';

export type FormStore = {
  formId?: string;
  control: Control<FieldValues>;
  watch: (name: string) => any;
  getValues: (() => { [fieldName: string]: any }) | ((key?: string) => any);
  setValue: (name: string, value: any, opts?: any) => void;
  register: UseFormRegister<{}>;
  reset: UseFormReset<{}>;
  resetField: UseFormResetField<{}>;
  setError: UseFormSetError<FieldValues>;
  clearErrors: UseFormClearErrors<FieldValues>;
  formState: any;
  setFormMethods: (methods: any) => void;
  isReady: boolean;
};

export const initialState = {
  control: {} as Control<FieldValues>,
  register: {} as UseFormRegister<{}>,
  watch: {} as UseFormWatch<{}>,
  reset: {} as UseFormReset<{}>,
  resetField: {} as UseFormResetField<{}>,
  setValue: () => {},
  setError: {} as UseFormSetError<{}>,
  clearErrors: {} as UseFormClearErrors<{}>,
  formState: {} as FormState<any>,
  getValues: () => ({}),
  isReady: false,
};

export const createFormStore = (initProps?: { formId: string }) => {
  return createStore<FormStore>()((set) => ({
    ...initProps,
    ...initialState,
    setFormMethods: (methods: any) =>
      set((state) => ({
        ...state,
        watch: methods.watch,
        control: methods.control,
        register: methods.register,
        formState: methods.formState,
        setValue: methods.setValue,
        getValues: methods.getValues,
        reset: methods.reset,
        resetField: methods.resetField,
        setError: methods.setError,
        clearErrors: methods.clearErrors,
        isReady: true,
      })),
  }));
};

export type FormStoreApi = ReturnType<typeof createFormStore>;

export const FormStoreContext = createContext<FormStoreApi | undefined>(undefined);
